var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors, spacing } from '../../styles/jss/variables';
import { tooltipClasses } from '@mui/material/Tooltip';
const CustomTooltip = styled((_a) => {
    var { className, children, title, offset } = _a, props = __rest(_a, ["className", "children", "title", "offset"]);
    const slotProps = offset
        ? {
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: { offset },
                    },
                ],
            },
        }
        : undefined;
    return (_jsx(Tooltip, Object.assign({}, props, { classes: { popper: className }, title: title, slotProps: slotProps, children: React.isValidElement(children) ? children : _jsx("span", {}) })));
})(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: Object.assign(Object.assign({}, theme.typography.xxs_regular), { backgroundColor: colors.background.WHITE, color: colors.backgroundText.WHITE, borderRadius: 0, border: `1px solid ${colors.black[300]}`, padding: `${spacing.xxs} 12px` }),
}));
export default CustomTooltip;
